import moment from "moment-timezone";

const AnalysisItem = (props) => {
  if (props.selectedDocument.session_id === props.document.session_id) {
    console.log(
      `Selected Session Id: ${props.selectedDocument.session_id}, Current Document Session Id: ${props.document.session_id}`
    );
  }

  return (
    <div
      onClick={() => props.onSelectDocument(props.document)}
      key={props.document.session_id}
      className={`flex hover:bg-gray-100 transition-colors duration-200 rounded-lg p-3 border border-gray-300 cursor-pointer ${
        props.selectedDocument.session_id === props.document.session_id
          ? "bg-gray-200"
          : "bg-white"
      }`}
    >
      <div className="flex items-center justify-between">
        <div>
          <span className="flex-shrink-0 text-purple-600 mr-3">✨</span>
        </div>

        <div className="flex flex-col justify-between mb-2">
          <p className="text-gray-700 text-md break-all">
            {props.document.session_id}
          </p>
          <p className="text-gray-400 text-sm break-all">
            {moment
              .tz(new Date(props.document.last_updated), "America/Los_Angeles")
              .format("MM-DD-YYYY hh:mm A")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnalysisItem;
